import { Injectable, computed, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class LanguageService {
    private readonly translateService = inject(TranslateService);

    public language = computed(() => {
        return this.translateService.getCurrentLang() ?? this.translateService.getFallbackLang() ?? "en-CA";
    });
}
